import api from './api'
import { Locale, FiltriLocali } from '../types'

// Import dati mock per fallback
import localiMock from '../data/locali.json'

interface LocaliResponse {
  locali: Locale[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

/**
 * Ottiene lista locali con filtri
 */
export async function getLocali(filtri?: FiltriLocali): Promise<Locale[]> {
  try {
    const params = new URLSearchParams()
    if (filtri?.provincia) params.set('provincia', filtri.provincia)
    if (filtri?.tipo) params.set('tipo', filtri.tipo)
    if (filtri?.fasciaPrezzo) params.set('fasciaPrezzo', filtri.fasciaPrezzo)
    if (filtri?.ricerca) params.set('q', filtri.ricerca)

    const query = params.toString()
    const response = await api.get<LocaliResponse>(`/locali${query ? `?${query}` : ''}`)
    return response.locali
  } catch (error) {
    console.warn('API non disponibile, uso dati mock:', error)
    // Fallback a dati mock
    let locali = localiMock as Locale[]

    if (filtri?.provincia) {
      locali = locali.filter(l => l.provincia === filtri.provincia)
    }
    if (filtri?.tipo) {
      locali = locali.filter(l => l.tipo === filtri.tipo)
    }
    if (filtri?.fasciaPrezzo) {
      locali = locali.filter(l => l.fasciaPrezzo === filtri.fasciaPrezzo)
    }
    if (filtri?.ricerca) {
      const search = filtri.ricerca.toLowerCase()
      locali = locali.filter(l =>
        l.nome.toLowerCase().includes(search) ||
        l.comune.toLowerCase().includes(search) ||
        l.specialita.some(s => s.toLowerCase().includes(search))
      )
    }

    return locali
  }
}

/**
 * Ottiene locali per la mappa (dati minimi)
 */
export async function getLocaliMappa(): Promise<Locale[]> {
  try {
    return await api.get<Locale[]>('/locali/mappa')
  } catch (error) {
    console.warn('API non disponibile, uso dati mock')
    return localiMock as Locale[]
  }
}

/**
 * Ottiene locali in evidenza
 */
export async function getLocaliInEvidenza(limit = 6): Promise<Locale[]> {
  try {
    return await api.get<Locale[]>(`/locali/in-evidenza?limit=${limit}`)
  } catch (error) {
    console.warn('API non disponibile, uso dati mock')
    return (localiMock as Locale[]).filter(l => l.inEvidenza).slice(0, limit)
  }
}

/**
 * Ottiene dettaglio locale per slug
 */
export async function getLocaleBySlug(slug: string): Promise<Locale | null> {
  try {
    return await api.get<Locale>(`/locali/${slug}`)
  } catch (error) {
    console.warn('API non disponibile, uso dati mock')
    return (localiMock as Locale[]).find(l => l.slug === slug) || null
  }
}

/**
 * Incrementa contatore visite
 */
export async function incrementaVisite(slug: string): Promise<void> {
  try {
    await api.post(`/locali/${slug}/visita`)
  } catch {
    // Ignora errori
  }
}
